export default __webpack_public_path__ + "static/media/06_eye_m.7d91af0e.webp";